import { audioManager } from './../objects/AudioManager';
import { IntUtil } from './../framework/utils/IntUtil';
import { getWorld } from "./WorldInfo";

const ALL_LEVELS: { [key: string]: LevelInfo } = {};

const COMMON_END_MESSAGES: { [key: string]: Array<string> } = {};

export function importCommonEndMessagesXML(xml: XMLDocument): void {
    let common = xml.getElementsByTagName('common')[0];
    let endms = common.getElementsByTagName('endMessage');
    for (let i = 0; i < endms.length; ++i) {
        let list: Array<string> = COMMON_END_MESSAGES[endms[i].getAttribute('state')];
        if (!list) {
            list = COMMON_END_MESSAGES[endms[i].getAttribute('state')] = [];
        }
        list.push(endms[i].textContent);
    }
}

export class LevelInfo {

    static fromString(level: string): LevelInfo {
        if (ALL_LEVELS[level]) {
            return ALL_LEVELS[level];
        }
        let params: Array<string> = level.split('-');
        let info: LevelInfo = new LevelInfo(params[1], parseInt(params[2]));
        if (info.worldCode) {
            let xml = getWorld(info.worldCode).getLevelXML(info.index);
            if (xml) {
                ALL_LEVELS[level] = info;
                info.importXML(xml);
                return info;
            }
        }
        return null;
    }

    static getLevel(worldCode: string, level: number): LevelInfo {
        return LevelInfo.fromString('level-' + worldCode + '-' + level);
    }

    calls: Array<string> = [];

    instructions: Array<string> = [];

    endMessages: { [key: string]: Array<string> } = {};

    constructor(public worldCode: string, public index: number) {
        if (isNaN(this.index)) {
            this.index = 0;
        }
        while (this.index > 10) {
            this.index -= 11;
        }
        while (this.index < 0) {
            this.index += 11;
        }
    }

    public get worldIndex(): number {
        return getWorld(this.worldCode).index;
    }

    public get isChallenge(): boolean {
        return this.index == 0;
    }

    public get level(): string {
        return 'level-' + this.worldCode + '-' + (this.index ? this.index : 'challenge');
    }

    public getNeighbor(dIndex: number): LevelInfo {
        return LevelInfo.fromString(new LevelInfo(this.worldCode, this.index + dIndex).level);
    }

    importXML(_xml: Element): void {
        if (_xml) {
            let calls = _xml.getElementsByTagName('call');
            for (let i = 0; i < calls.length; ++i) {
                this.calls.push(calls[i].textContent);
            }

            let insts = _xml.getElementsByTagName('instruction');
            for (let i = 0; i < insts.length; ++i) {
                this.instructions.push(insts[i].textContent);
            }

            let endms = _xml.getElementsByTagName('endMessage');
            for (let i = 0; i < endms.length; ++i) {
                let list: Array<string> = this.endMessages[endms[i].getAttribute('state')];
                if (!list) {
                    list = this.endMessages[endms[i].getAttribute('state')] = [];
                }
                list.push(endms[i].textContent);
            }
        }
    }

    listEndMessages(state: 'best' | 'pass' | 'fail'): { list: Array<string>, audio: string } {
        let list = this.endMessages[state];
        let audio = '';

        if (!list) {
            let commonlist = COMMON_END_MESSAGES[state];
            let index: number = IntUtil.random(commonlist.length - 1);
            list = [commonlist[index]];
            let indexStr: string = '' + (index + 1);

            while (indexStr.length < 3) {
                indexStr = '0' + indexStr;
            }
            if (state == 'fail') {
                audio = 'assets/audio/Failure/FSO5_Failure_' + indexStr + '.mp3';
            } else if (state == 'pass') {
                audio = 'assets/audio/Success/FSO5_Success_' + indexStr + '.mp3';
            }
        } else if (state == 'fail') {
            audio = audioManager.getWorldAudioUrl(this.worldIndex, 36);
        } else if (state == 'pass') {
            audio = audioManager.getWorldAudioUrl(this.worldIndex, 32);
        } else if (state == 'best') {
            audio = audioManager.getWorldAudioUrl(this.worldIndex, this.isChallenge ? 35 : (1 + this.index * 3));
        }

        return { list: list, audio: audio };
    }
}



// WEBPACK FOOTER //
// ./src/data/LevelInfo.ts